import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s10/b1.jpeg');

class Services_10 extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner
            title="Secure Entry. Authorized Flow. Trusted Every Time."
            pagename="Door Access Control"
            bgimage={bnrimg}
          />

          <div className="section-full p-tb80 inner-page-padding">
            <div className="container">
              <div className="blog-single-wrap-width">
                <div className="blog-post date-style-3 blog-detail text-black">
                  <div className="mt-post-media clearfix m-b30">
                    <ul className="grid-post">
                      <li>
                        <div className="portfolio-item">
                          <img
                            className="img-responsive"
                            src={require("./../../images/s10/b2.jpg")}
                            alt="Door Access Control System"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="mt-post-title">
                    <h3 className="post-title font-weight-600">Door Access Control</h3>
                  </div>

                  <div className="mt-post-text">
                    <p><strong>"Controlled access is the backbone of secure operations."</strong></p>

                    <p>
                      At <strong>I‑Smart Engineering Works</strong>, we deploy advanced door access systems with military-style rigor. Leveraging biometric, RFID, and PIN-based technologies, our solutions ensure only authorized personnel gain entry—every time, without compromise.
                    </p>

                    <p>
                      Designed for high-traffic offices, sensitive zones, data centres, and industrial facilities, our systems integrate seamlessly with CCTV, alarms, and emergency protocols—providing a unified security ecosystem.
                    </p>

                    <h4 className="font-weight-600">Our Access Control Services Include:</h4>
                    <ul className="list-angle-right">
                      <li>Biometric readers (fingerprint/iris/face) and RFID card systems</li>
                      <li>Secure door controllers, electric locks, and exit devices</li>
                      <li>Integration with CCTV and fire alarm systems</li>
                      <li>Centralized logging and real-time monitoring</li>
                      <li>Emergency override, lockdown, and muster-point support</li>
                      <li>AMC for firmware updates, audits, and system health checks</li>
                    </ul>

                    <blockquote className="bg-dark text-white author-quote">
                      <h4 className="m-b0">
                        “Onboard our fleet, no one enters unless cleared. Your facility deserves the same discipline.” <i className="fa fa-quote-right" />
                      </h4>
                      <div className="p-t15 text-white">
                        <strong className="text-primary">Lt. Commander J. Roberts</strong>
                        <span>Naval Security Division</span>
                      </div>
                    </blockquote>

                    <p>
                      We follow global security standards, rigorous testing, and clean installation protocols to maintain integrity and uptime. When each entry matters, trust systems built with military-level reliability.
                    </p>

                    <p>
                      <strong>Need layered access control that never falters?</strong> Connect with us for a security audit and customized deployment plan.
                    </p>

                    <p>
                      We proudly collaborate with industry-leading brands such as <strong>ESSL</strong>, <strong>Honeywell</strong>, and other trusted access control system providers—ensuring every deployment meets the highest global standards.
                    </p>

                  </div>

                  <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        <div className="widget widget_tag_cloud">
                          <h4 className="tagcloud">Tags</h4>
                          <div className="tagcloud">
                            <NavLink to="#">Access Control</NavLink>&nbsp;
                            <NavLink to="#">Biometric</NavLink>&nbsp;
                            <NavLink to="#">RFID</NavLink>&nbsp;
                            <NavLink to="#">Secure Entry</NavLink>&nbsp;
                            <NavLink to="#">AMC Access</NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Services_10;
